<button (click)="search.emit(item)" [title]="'catalog.dashboard.search' | transloco" class="relative">
  @if (item.image) {
    <img
      [alt]="item.title || item.subtitle"
      [src]="item.image"
      class="max-w-none w-full"
      mat-card-image
    />
  }

  <div [style.background]="styleBackground" class="absolute top-0 left-0 right-0 bottom-0"></div>

  <div class="p-3 absolute bottom-0 text-left text-white z-10">
    <div>
      @if (item.title) {
        <span class="mat-title-medium drop-shadow-[0_1px_1px_rgba(0,0,0,1.0)]">
          {{ item.title }}
        </span>
      }

      <small class="mr-2 mat-title-small drop-shadow-[0_1px_1px_rgba(0,0,0,1.0)]">
        {{ item.subtitle }}
      </small>
    </div>


    @if (item.description) {
      <div class="mat-body-medium drop-shadow-[0_1px_1px_rgba(0,0,0,1.0)]">
        {{ item.description }}
      </div>
    }
  </div>
</button>
